import createSubscriptionChannel from '@/store/sagas/createSubscriptionChannel'
import { ONLINE_USERS_TOPIC } from '@/constants/socket/events'

export const createOnlineUsersChannel = () => (
  createSubscriptionChannel(ONLINE_USERS_TOPIC)
)

export default createOnlineUsersChannel